var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocationPointer = function SvgLocationPointer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32268 2.28737C5.41342 -0.762458 10.42 -0.762458 13.5107 2.28737C16.6076 5.3433 16.6076 10.3026 13.5107 13.3585C13.5065 13.3627 13.5022 13.3668 13.4979 13.3709L8.4892 18.1064C8.16795 18.4101 7.66543 18.4101 7.34418 18.1064L2.33549 13.3709C2.33118 13.3668 2.32691 13.3627 2.32268 13.3585C-0.774228 10.3026 -0.774228 5.3433 2.32268 2.28737ZM12.3401 3.47371C9.89835 1.06432 5.93503 1.06432 3.49332 3.47371C1.05984 5.87499 1.05779 9.76233 3.48718 12.1661L7.91669 16.354L12.3462 12.1661C14.7756 9.76232 14.7735 5.87499 12.3401 3.47371Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58335 7.91669C4.58335 6.07574 6.07574 4.58335 7.91669 4.58335C9.75765 4.58335 11.25 6.07574 11.25 7.91669C11.25 9.75765 9.75765 11.25 7.91669 11.25C6.07574 11.25 4.58335 9.75765 4.58335 7.91669ZM7.91669 6.25002C6.99621 6.25002 6.25002 6.99621 6.25002 7.91669C6.25002 8.83717 6.99621 9.58336 7.91669 9.58336C8.83717 9.58336 9.58336 8.83717 9.58336 7.91669C9.58336 6.99621 8.83717 6.25002 7.91669 6.25002Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationPointer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-pointer.c6f645c3.svg";
export { ForwardRef as ReactComponent };